import React from 'react';
import { Alert } from 'reactstrap';

const AlertComponent = (props) => {
 


  return (
  
       <Alert color={props.color} isOpen={props.alert} toggle={props.onDismiss}>
{props.message}
    </Alert>
    
  )
}
export default AlertComponent;




